module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.confirm()
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "numero"
    }
  }, [_vm._v("La liste des Rondes à importer au format .xlsx")]), _vm._v(" "), _c('input', {
    ref: "fileInput",
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "accept": ".xlsx",
      "id": "numero",
      "name": "file",
      "maxlength": "50",
      "required": ""
    },
    on: {
      "change": function($event) {
        _vm.getfile($event)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('button', {
    staticClass: "btn btn-primary"
  }, [_vm._v("Confirmer")]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("\n      Annuler\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7f1e861b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/rondes/RondeFormCsv.vue
// module id = 1830
// module chunks = 2